import { RouteConfig } from 'vue-router'
import Main from '../Warning/Main.vue'

export const warningRoutes: RouteConfig = {
  path: '/warning',
  name: 'warning',
  component: Main
}
